module.exports = __webpack_public_path__ + "static/media/behance-logo.9841f05f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/behance-logo.svg
// module id = 178
// module chunks = 0